import {useEffect, useState} from "react";
import {useUserServerRoute} from "./useUserServerRoute";
import {CrudPageV2} from "../../../Modules/CrudPageV2/CrudPageV2";


export const useServerRoutes = () => {

    const {serverMenus} = useUserServerRoute();

    const [userRoutes, setUserRoutes] = useState([]);

    const getElementByCode = (menu) => {
        const code = menu.reactElement.code;
        switch (code) {
            case 'CrudPageV2':
                return <CrudPageV2 menu={menu}/>;
            default:
                return <h2>Código não mapeado: {code}</h2>
        }
    }

    useEffect(() => {

        const filterOnlyMenus = (menus) => {
            if (!menus) {
                return [];
            }

            return menus.map(x => ({...x})).filter((x) => {

                if (x.reactElement) {
                    x.element = getElementByCode(x)
                }

                if (!x.element) {
                    return false;
                }

                x.children = filterOnlyMenus(x.children);

                return true;
            }).filter(x => x);
        }


        const userMenu = filterOnlyMenus(serverMenus);
        setUserRoutes(userMenu);
    }, [serverMenus]);


    return {
        userRoutes
    }

}
